var render, staticRenderFns
import script from "./DefaultFallback.vue?vue&type=script&lang=js&"
export * from "./DefaultFallback.vue?vue&type=script&lang=js&"
import style0 from "./DefaultFallback.vue?vue&type=style&index=0&id=45656790&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45656790",
  null
  
)

export default component.exports